/** @flow */

export default {
  en: {
    RESUME_FILE_LOAD: "Resume File Load",
    RESUME: "Resume",
    LOAD_NEW_DATA: "Load New Data",
    UPLOADING: "File is being uploaded",
    LOAD_NEW_DATA_DESCRIPTION: "Import new records to the database",
    LOAD_DATA: "Load Data",
    EXPORT_CURRENT_DATA: "Export Current Data",
    TRANSFER_FILE: "Transfer File",
    EXPORT_CURRENT_DATA_DESCRIPTION:
      "Export Hierarchy Data, Staff In Post, Historic, Historic Absence Data or GoodShapeCentral! Accounts",
    EXCHANGE_DATA: "Exchange Data",
    TRANSFER_FILES: "Transfer Files",
    DATA_EXPORT: "Data Export",
    EXPORT_HISTORY: "Export History",
    DATA_QUALITY: "Data Quality",
    DATA_TRANSFER: "Data Transfer",
    TRANSFER_DATA_FILE: "Transfer Data File",
    TRANSFER_FILE_HISTORY: "Transfer File History",
    HELP_AND_SUPPORT: "Help & Support",
    FIELD_GUIDE: "Field Guide",
    EXCEPTIONS_GUIDE: "Exceptions Guide",
    TROUBLESHOOTING: "Troubleshooting",
    DATA_FILE_ARCHIVE: "Data File Archive",
    DATA_FILE_ARCHIVE_DESCRIPTION:
      "View a list of historic files that have been processed or cancelled",
    VIEW_ARCHIVE: "View Archive",
    LAST_EDITED_BY: "Last Edited By",
    FILE_TYPE: "File Type",
    LOAD_NEW_DATA_DISABLED_WARNING:
      "Loading of new data is disabled as there’s a prior import exceptions review in progress.",
    FILTER_DATA_TYPE: "Data Type",
    HIERARCHY_LOAD: "Hieararchy Load",
    STAFF_IN_POST: "Staff in Post",
    HISTORIC_ABSENCE: "Historic Absence",
    PROCESSED: "Processed",
    CANCELLED: "Cancelled",
    COLUMN_FILE_ID: "File ID",
    COLUMN_DATE_LOADED: "Date Loaded",
    COLUMN_LOADED_BY: "Loaded By",
    COLUMN_DATA_TYPE: "Data Type",
    COLUMN_HIERARCHY_AREA: "Hierarchy Area",
    COLUMN_TOTAL_DATA_ROWS: "Total Data Rows",
    COLUMN_TOTAL_CHANGES: "Total Changes",
    COLUMN_TOTAL_EXCEPTIONS: "Total Exceptions",
    COLUMN_STATUS: "Status",
    CHANGE_TYPE_ID: "Change Type ID",
    CHANGE_NAME: "Change Name",
    VIEW_DETAILS: "View Details",
    LAST_WORKED_ON: "Last Worked on",
    RESUME_CURRENT_DATA: "Resume Current Data",
    HISTORIC_ABSENCE_DATA_EXCEPTIONS: "Historic Data Exceptions",
    STAFF_IN_POST_DATA_EXCEPTIONS: "Staff in Post Data Exceptions",
    HIERARCHY_LOAD_DATA_EXCEPTIONS: "Hierarchy Data Exceptions",
    MY_FIRSTCARE_ACCOUNTS_LOAD_DATA_EXCEPTIONS: "My GoodShape accounts Data Exceptions",
    ABANDON: "Abandon",
    CONFIRM_SELECTION: "Confirm selection",
    CONFIRM_DATA_TO_BE_BLOCKED: "Confirm Data to be Blocked",
    EXCEPTION_TYPE_MSG_BLOCKED:
      "All records in this section will be blocked. Please review and confirm.",
    EXCEPTION_TYPE_MSG_MANUAL:
      "Review and select the records which you would like to allow to go through. The rest will be blocked.",
    EXCEPTION_TYPE_MSG_USER_ACKNOWLEDGMENT:
      "All records in this section will be allowed through. Please review and acknowledge.",
    EXCEPTION_TYPE_MSG_INCORRECT_PHONE_NUMBER:
      "All mobile numbers in this section will be blocked. Please review and acknowledge.",
    EXIT: "Exit",
    PROCESS_FILE: "Process File",
    SELECTED_EXCEPTIONS: "{value} selected",
    DESELECT_ALL: "Deselect all",
    FILE_STATUS: "File Status",
    VALIDATING_FILE_FAILED: "Validating File Failed",
    VALIDATING_FILE_FAILED_WARNING:
      "Failed to validate imported file. Please delete file and import again",
    ROW: "Row",
    EXCEPTION_DETAILS: "Exception Details",
    LAST_CHANGES: "Manual change made in the last 24 hours",
    ACKNOWLEDGE_AND_CONTINUE: "Acknowledge and Continue",
    USE_DEFAULT: "Use Default ({value}) ",
    SELECTED_EXCEPTIONS_SUMMARY: "{blocked} blocked and {allowed} allowed to go through",
    DEPARTMENT_REF: "Department Ref",
    Department: "Department",
    DIRECTORATE: "Directorate",
    POSITION_START_LESS_DOB: "Position Start < DOB",
    EMPLOYMENT_START_LESS_DOB: "Employment Start < DOB",
    UNSAVED_CHANGES: "Unsaved Changes",
    UNSAVED_CHANGES_TEXT:
      "There are unsaved changes in the currently open section. \n" +
      "Would you like to save or discard them?",
    DISCARD_CHANGES: "Discard Changes",
    FILE_CHANGES_SUMMARY: "File Changes Summary",
    FILE_CHANGES_DETAILS: "File Changes Details",
    SELECT_TYPE_ON_PAGE: "{type} All on Page",
    SELECT_TOTAL_EXCEPTIONS: "{type} All ({total})",
    TODAYS_DATE: "Todays Date",
    MOVED_TO_UNASSIGNED: "Move to Unassigned",
    NO_ASSIGNMENT: "Continue without Assignment",
    CLOSE_ABSENCES: "Close Absences",
    PROCESSING_FILE: "Processing File",
    PROCESSING: "Processing",
    LOADING: "Loading",
    VALIDATING: "Validating",
    VALIDATING_SIP_FILE: "Validating SIP file",
    QUEUED: "Queued",
    QUEUE_FILE_SUBMITTED_BY: "File Submitted by {name} on {date}",
    QUEUE_CURRENT_POSITION: "Current Queue Position: {position}",
    YOU_ARE_NEXT: "You are next",
    UPLOADING_PLEASE_WAIT: "Uploading, please wait... ",
    VIEW_EXCEPTIONS: "View Exceptions",
    COMPLETE: "Complete",
    IN_PROGRESS: "IN PROGRESS",
    EMPLOYEES_RECORDS: "Employees Records",
    DATE_EXPORTED: "Date Exported",
    EXPORT_ID: "Export ID",
    EXPORTED_BY: "Exported By",
    HIERARCHY_AREA: "Hierarchy Area",
    DONE: "DONE",
    PENDING: "Pending",
    UPDATING_EMPLOYEES: "Updating Employee Details",
    UPDATING_POSITIONS_AND_NOTIFICATIONS: "Updating Notification Contacts",
    PROCESSING_PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCES: "Processing Leavers with Open Absences",
    PROCESSING_FUTURE_LEAVERS: "Processing Future Leavers",
    PREPARING_DATA_IMPORT_FILE_TO_BE_PROCESSED: "Preparing data",
    NOT_STARTED: "NOT STARTED",
    FAILED: "Failed",
    FILE_ID: "File Id",
    DATE_TRANSFERRED: "Date Transferred",
    TRANSFERRED_BY: "Transferred By",
    PLEASE_WAIT: "Please wait, your file is being prepared for download",
    SET_LEAVE_DATE_AND_MARK_POSITIONS_INACTIVE: "Mark employee leaver and its positions inactive",
    DATA_QUALITY_ISSUES: "Data Quality Issues",
    TOTAL_DATA_MEASURES: "Total Data Measures",
    DATA_MEASURES_IN_GOOD_HEALTH: "Data Measures in Good Health",
    DATA_MEASURES_IN_MIXED_HEALTH: "Data Measures in Mixed Health",
    DATA_MEASURES_IN_POOR_HEALTH: "Data Measures in Poor Health",
    DATA_QUALITY_MEASURES: "Data Quality Measures",
    QUANTITY: "Quantity",
    STATUS: "Status",
    IMPACT: "Impact",

    // EXCEPTIONS TYPES
    MISSING_EMPLOYEE_REFERENCE: "Missing Employee Ref",
    MISSING_FIRST_NAME: "Missing First Name",
    MISSING_SURNAME: "Missing Surname",
    MISSING_DATE_OF_BIRTH: "Missing Date Of Birth",
    MISSING_CONTRACTED_HOURS: "Missing Contracted Hours",
    MISSING_WORKING_DAYS: "Missing Working Days",
    MISSING_NOTIFICATION_CONTACTS: "Missing Notification Contacts",
    MISSING: "Missing",
    DUPLICATE_EMPLOYEE_REFERENCE: "Duplicate Employee Ref",
    DUPLICATE_EMAIL_ADDRESS: "Duplicate Email Address",
    DUPLICATE_POSITION: "Duplicate Position",
    INVALID_EMAIL_DOMAIN: "Invalid Email Domain",
    INVALID_EMAIL_ADDRESS: "Invalid Email Address",
    DATE_JOINED_ORGANISATION_EARLIER_THAN_DOB: "Date Joined Organisation Earlier Than DOB",
    DATE_OF_EMPLOYMENT_END_IS_EARLIER_THAN_EMPLOYMENT_START_DATE:
      "Date of Employment End Is Earlier Than Employment Start Date",
    POSITION_END_DATE_IS_EARLIER_THAN_POSITION_START_DATE:
      "Position End Date Is Earlier than Position Start Date",
    UNABLE_TO_ALLOCATE_DEPARTMENT: "Unable To Allocate Department",
    UNABLE_TO_ALLOCATE_STAFF_GROUP: "Unable To Allocate Staff Group",
    UNABLE_TO_ALLOCATE_SHIFT_PATTERN: "Unable To Allocate Shift Pattern",
    PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCE: "Past Or Current Leavers With Open Absence",
    NOTIFICATION_CONTACT_DOES_NOT_EXIST: "Notification Contact Does Not Exist",
    NOTIFICATION_CONTACT_IS_A_LEAVER: "Notification Contact Is A Leaver",
    NOTIFICATION_CONTACT_DOES_NOT_HAVE_AN_EMAIL_ADDRESS:
      "Notification Contact Does Not Have An Email Address",
    POTENTIAL_LEAVERS: "Potential Leavers",
    POTENTIAL_INCORRECT_WORKING_DAYS: "Potential Incorrect Working Days",
    POTENTIAL_INCORRECT_CONTRACTED_HOURS: "Potential Incorrect Contracted Hours",
    POTENTIAL_INCORRECT_DATE_OF_BIRTH: "Potential Incorrect Date Of Birth",
    POTENTIAL_INCORRECT_PHONE_NUMBER: "Potential Incorrect Phone Number",
    EMAIL_ADDRESS_THAT_WILL_BE_DELETED: "Warning: Email Address That Will be Deleted",
    MOBILE_NUMBERS_THAT_WILL_BE_DELETED: "Warning: Mobile Numbers That Will be Deleted",
    FUTURE_LEAVERS_WITH_OPEN_ABSENCE: "Future Leavers With Open Absence",
    EMAIL_ADDRESS_NOT_PERMITTED: "Email Address Not Permitted",
    EMPLOYEE_SURNAME: "Surname Update",
    EMPLOYEE_FIRST_NAME: "First Name Update",
    POSITION_DEPARTMENT: "Department Move",
    EMPLOYEE_EMAIL_ADDRESS: "Email Update",
    EMPLOYEE_PHONE_NUMBER: "Phone Number Update",
    POSITION_CONTRACTED_HOURS: "Contract Hours Update",
    POSITION_WORKING_DAYS: "Working Days Update",
    POSITION_STAFF_GROUP: "Staff Group",
    POSITION_SHIFT_PATTERN: "Shift Pattern",
    EMPLOYEE_LEAVING_DATE: "Leaver",
    EMPLOYEE_ADDED: "New Starter",
    MUST_BE_XLS_XLSX_CSV: "Must be XLS, XLSX or CSV",
    NOTIFICATION_CONTACT_ADDED: "Added Notification Contacts",
    NOTIFICATION_CONTACT_REMOVED: "Removed Notification Contacts",
    NOTIFICATION_CONTACT_TYPE: "Updated Notification Type",
    RECORD: "Record",
    OLD_VALUE: "Old Value",
    NEW_VALUE: "New Value",

    NO_FILE_LINE_1: "Need to load a new SIP file?",
    NO_FILE_LINE_2: "Get started by clicking the Load New Data button below.",
    LOADING_LINE_1: "Your file is currently being uploaded to the system.",
    LOADING_LINE_2: "Validation of the file will commence automatically once loaded.",
    VALIDATING_LINE_1:
      "Your file is currently being validated to verify it is in an acceptable format.",
    VALIDATING_LINE_2:
      "If your file fails validation please consult with the Troubleshooting Guide in the Help & Support section.",
    PENDING_LINE_1: "Your file has successfully been validated.",
    PENDING_LINE_2: "Click the Resume button to review and manage the identified exceptions.",
    QUEUED_LINE_1: "Validation of the SIP File has successfully completed.",
    QUEUED_LINE_2:
      "Processing will take place automatically and you can safely navigate to another page if you wish.",
    PROCESSING_LINE_1: "Your File is currently processing.",
    PROCESSING_LINE_2: "The table below will automatically update as it progresses.",
    COMPLETE_LINE_1: "Your SIP File has been processed successfully.",
    COMPLETE_LINE_2: "You can now close this section.",
    TRANSFER_DATA_INFO_LINE_1:
      "Need to securely transfer a data file containing sensitive information?",
    TRANSFER_DATA_INFO_LINE_2:
      "Click Choose File to select your data file and then press the Transfer File button.",
    TRANSFER_DATA_INFO_LINE_3:
      "Your file will be securely uploaded and will appear in the Transfer File History table on the right.",
    TRANSFER_DATA_INFO_LINE_4:
      "Access to download transferred files is restricted to Client Admin and Data Transfer users, in addition to the GoodShape Client Services team.",
  },
};
